import { FC } from 'react';
import { useRecoilValue } from 'recoil';
import { HELP_ROUTE } from 'components/help/constants';
import { Permission } from 'common/graphqlTypes';
import PageHeader from 'components/common/PageHeader/PageHeader';
import TimeRangeDropdown from 'components/common/TimeRangeDropdown/TimeRangeDropdown';
import { queryTimeRangeState } from 'components/common/Managers/RouteStateManager.state';
import { timezoneState } from 'components/common/Managers/PreferencesManager.state';
import { accountDataState, hasPermissionState } from 'components/account/account.state';
import { getDateRangeText, getFormattedTimeOffsetUTC, getTimezoneOffset, parseTimeRange } from 'common/util/time';

import './MonitorsHeader.scss';
import ELEMENT from 'common/element';

const MonitorsHeader: FC = () => {
  const timezone = useRecoilValue(timezoneState);
  const timezoneOffset = getTimezoneOffset(timezone);

  const queryTimeRange = useRecoilValue(queryTimeRangeState);
  const { startTime, endTime } = parseTimeRange(queryTimeRange, timezone);
  let formattedTime = '';

  if (startTime && endTime) {
    formattedTime =
      getDateRangeText(startTime.milliseconds, endTime.milliseconds, timezone) +
      '  ' +
      getFormattedTimeOffsetUTC(timezoneOffset);
  }
  const leftButtons = [
    {
      children: (
        <div key="TimeRange" className="MonitorsPage__TimeRange" data-test-id={ELEMENT.monitorsTimeRange}>
          {formattedTime}
        </div>
      ),
    },
  ];
  const accountData = useRecoilValue(accountDataState);
  const { isSingularityXDRUser = false } = accountData;

  const hasFullAccessPermission = useRecoilValue(hasPermissionState(Permission.fullAccess));

  const hasXdrUserPermission = useRecoilValue(hasPermissionState(Permission.xdrUser));

  function hasRequiredPermissions(): boolean {
    return (!isSingularityXDRUser && hasFullAccessPermission) || (isSingularityXDRUser && hasXdrUserPermission);
  }

  const rightButtons = [
    {
      key: 'Edit JSON',
      name: 'Edit JSON',
      link: '/file?path=/scalyr/monitors',
      disabled: !hasRequiredPermissions(),
      testId: ELEMENT.monitorsJSONLink,
    },
    {
      children: <TimeRangeDropdown key="TimeRangeDropdown" />,
    },
  ];

  return (
    <PageHeader
      title="Monitors"
      helpLink={HELP_ROUTE.HELP_MONITORS}
      additionalRightButtons={rightButtons}
      additionalLeftButtons={leftButtons}
    />
  );
};

export default MonitorsHeader;
